import { Row, Col } from 'react-bootstrap';
import { GridCell } from './GridCell';
import { templates } from '../../Misc/Templates';
import { Grid } from 'react-bootstrap-icons';

// Non-quarter templates can be handled easily - there is no nested structure, so it just iterates over their definition row by row and col by col
const renderStandardGrid = (template, props) => (
    <div>
        {templates[template].map((row, index) => (
            <Row key={index}>
                {row.map((block) => (
                    <GridCell key={block.id} block={block} {...props} />
                ))}
            </Row>
        ))}
    </div>
);

// The quarter templates need to be rendered slightly differently, since they have a nested bootstrap grid (one larger box to the right or left and 2-4 boxes on the other side from it). This can be handled more elegantly, but it is pretty readable as it is set up here
const renderQuarterGrid = (template, props) => {
    const templateData = templates[template];
    const isLeft = template.includes('LEFT');
    const is1x1 = template.includes('1_1');
    const is2x2 = template.includes('2_2');
    
    if (is1x1) {
        return (
            <div>
                <Row>
                    {isLeft ? (
                        <>
                            <GridCell block={templateData[0][0]} {...props} />
                            <Col>
                                <Row><GridCell block={templateData[0][1]} {...props} /></Row>
                                <Row><GridCell block={templateData[0][2]} {...props} /></Row>
                            </Col>
                        </>
                    ) : (
                        <>
                            <Col>
                                <Row><GridCell block={templateData[0][0]} {...props} /></Row>
                                <Row><GridCell block={templateData[0][1]} {...props} /></Row>
                            </Col>
                            <GridCell block={templateData[0][2]} {...props} />
                        </>
                    )}
                </Row>
                {templateData.slice(1).map((row, index) => (
                    <Row key={index + 1}>
                        {row.map((block) => (
                            <GridCell key={block.id} block={block} {...props} />
                        ))}
                    </Row>
                ))}
            </div>
        );
    }

    if (is2x2) {
        return (
            <div>
                <Row>
                    {isLeft ? (
                        <>
                            <GridCell block={templateData[0][0]} {...props} />
                            <Col>
                                <Row>
                                    <GridCell block={templateData[0][1]} {...props} />
                                    <GridCell block={templateData[0][2]} {...props} />
                                </Row>
                                <Row>
                                    <GridCell block={templateData[0][3]} {...props} />
                                    <GridCell block={templateData[0][4]} {...props} />
                                </Row>
                            </Col>
                        </>
                    ) : (
                        <>
                            <Col>
                                <Row>
                                    <GridCell block={templateData[0][0]} {...props} />
                                    <GridCell block={templateData[0][1]} {...props} />
                                </Row>
                                <Row>
                                    <GridCell block={templateData[0][2]} {...props} />
                                    <GridCell block={templateData[0][3]} {...props} />
                                </Row>
                            </Col>
                            <GridCell block={templateData[0][4]} {...props} />
                        </>
                    )}
                </Row>
                {templateData.slice(1).map((row, index) => (
                    <Row key={index + 1}>
                        {row.map((block) => (
                            <GridCell key={block.id} block={block} {...props} />
                        ))}
                    </Row>
                ))}
            </div>
        )
    }
};

// Handle the grid structuring
export function CampaignGrid({ template, selectFunc, selected, hoverFunc, products, page, activeGrids, currentUser }) {
    const props = { selectFunc, selected, hoverFunc, products, page, activeGrids, currentUser };
    
    if (template.includes("QUARTER")) {
        return renderQuarterGrid(template, props);
    }
    
    return renderStandardGrid(template, props);
}